import { ReactNode } from "react";

export enum LinkRel {
  NOFOLLOW = "nofollow",
  NOOPENER = "noopener",
  NOREFERRER = "noreferrer",
}
export interface BaseLinkProps {
  destination: string;
  className?: string;
  relativePath?: boolean;
  target?: "_self" | "_blank";
  rel?: LinkRel;
}

export type LinkProps = BaseLinkProps & {
  children: ReactNode;
  type?: string;
  transformCase?: boolean;
  handleClick?: () => void;
  testId?: string;
  isMobile?: boolean;
};

export default function Link({
  destination,
  className,
  children,
  relativePath = true,
  target = "_self",
  rel,
  type,
  transformCase = false,
  handleClick,
  testId = "link",
  isMobile = false,
}: LinkProps) {
  const href = transformCase ? destination.toLowerCase() : destination;
  const defaultClass = isMobile ? undefined : `text-sm text-text-muted`;
  return (
    <a
      href={relativePath ? `/${href}` : href}
      className={className ?? defaultClass}
      target={target}
      rel={rel}
      type={type}
      onClick={handleClick}
      data-testid={testId}
    >
      {children}
    </a>
  );
}
